import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { actions } from 'core/redux';

export const makeCheckIsAnyDialogActive =
  (dispatch: Dispatch<AnyAction>) => (isActive: boolean) => {
    dispatch(actions.setInnerDialogsOpen(isActive));
  };
